<div class="grid-btnActions btn-group-sm" role="group">
  <button
    [id]="'startStopButton#' + data.id"
    type="button"
    class="btn btn-primary mr-1"
    data-toggle="tooltip"
    [title]="isRunning ? 'Stop replication' : 'Start replication'"
    [disabled]="isReadOnly || !bStartStopEnabled"
    [attr.aria-label]="(isRunning ? 'Stop replication' : 'Start replication') + ' for configuration ' + data.name"
    (click)="startStopReplication()"
  >
    @if (bStartStopEnabled) {
    <span class="fa fa-fw {{ isRunning ? 'fa-stop' : 'fa-play' }}" aria-hidden="true"></span>
    } @if (!bStartStopEnabled) {
    <span class="fa fa-fw fa-spinner fa-spin" aria-live="polite" aria-busy="true" aria-hidden="true"></span>
    }
  </button>
  <a
    class="btn btn-dark mr-1"
    data-toggle="tooltip"
    [title]="
      isSaaS
        ? 'Add or manage connections to Dynamics 365, SharePoint (including user mapping, permission mapping and explicit folder permissions) and/or Microsoft Entra ID'
        : 'Add or manage connections to Dynamics 365, SharePoint (including user mapping, permission mapping and explicit folder permissions), Active Directory and/or Microsoft Entra ID'
    "
    [attr.aria-label]="'Connections of configuration ' + data.name"
    [routerLink]="[data.id, 'connections']"
    (click)="navigateTo($event, [data.id, 'connections'])"
  >
    <span class="fa fa-fw fa-plug" aria-hidden="true"></span>
  </a>
  <a
    class="btn btn-dark mr-1"
    data-toggle="tooltip"
    title="View logs"
    [attr.aria-label]="'History logs for configuration ' + data.name"
    [routerLink]="[data.id, 'logs', 'history-logs']"
    (click)="navigateTo($event, [data.id, 'logs', 'history-logs'])"
  >
    <span class="fa fa-fw fa-file-text-o" aria-hidden="true"></span>
  </a>
  <a
    class="btn btn-dark mr-1"
    [class.disabled]="isReadOnly || data.status !== ServiceStatus.Started"
    data-toggle="tooltip"
    title="Overwrite Folder Permissions"
    [attr.aria-label]="'Overwrite Folder Permissions for configuration ' + data.name"
    [routerLink]="[data.id, 'overwrite-folder-permissions']"
    (click)="navigateTo($event, [data.id, 'overwrite-folder-permissions'])"
  >
    <span class="fa fa-fw fa-folder-open-o" aria-hidden="true"></span>
  </a>
  <a
    class="btn btn-dark mr-1"
    data-toggle="tooltip"
    title="SharePoint Structure Creator"
    [attr.aria-label]="'SharePoint Structure Creator for configuration ' + data.name"
    [routerLink]="[data.id, 'sharepoint-structure-creator']"
    (click)="navigateTo($event, [data.id, 'sharepoint-structure-creator'])"
  >
    <span class="fa fa-fw fa-sitemap" aria-hidden="true"></span>
  </a>

  <div class="mr-1" ngbDropdown container="body">
    <button
      class="btn btn-sm btn-secondary dropdown-toggle"
      [id]="'quickActionsMenuButton#' + data.id"
      data-toggle="tooltip"
      title="Quick Actions"
      ngbDropdownToggle
      [attr.aria-label]="'Open quick actions for configuration ' + data.name + '. Press ESC to close the dropdown.'"
    >
      <span class="fa fa-bolt" aria-hidden="true"></span>
    </button>
    <div ngbDropdownMenu [attr.aria-labelledby]="'quickActionsMenuButton#' + data.id">
      <button
        ngbDropdownItem
        data-toggle="tooltip"
        title="Reload the whole security model and check all SharePoint document locations"
        (click)="forceFullIteration()"
        [disabled]="isReadOnly || data.status !== ServiceStatus.Started"
      >
        <span class="fa fa-fw fa-retweet mr-1" aria-hidden="true"></span>Force full iteration
      </button>
      <button
        ngbDropdownItem
        data-toggle="tooltip"
        title="Force overwriting permissions even when there is no change from the Dynamics 365 side"
        (click)="clearSpPermissionsCache()"
        [disabled]="isReadOnly || data.status !== ServiceStatus.Stopped"
      >
        <span class="icon-stack mr-1" aria-hidden="true">
          <i class="fa fa-fw fa-database" aria-hidden="true"></i>
          <i class="fa fa-fw fa-lock icon-stack-smaller-light" aria-hidden="true"></i>
        </span>
        Clear SharePoint permissions cache
      </button>
      @if (data.groupStorage === GroupStorage.SharePoint) {
      <button
        ngbDropdownItem
        data-toggle="tooltip"
        title="Remove all cached groups and group members from your local database"
        (click)="clearSpGroupCache()"
        [disabled]="isReadOnly || data.status !== ServiceStatus.Stopped"
      >
        <span class="icon-stack mr-1" aria-hidden="true">
          <i class="fa fa-fw fa-database" aria-hidden="true"></i>
          <i class="fa fa-fw fa-users icon-stack-smaller-light" aria-hidden="true"></i>
        </span>
        Clear SharePoint group cache
      </button>
      }
      <button
        ngbDropdownItem
        data-toggle="tooltip"
        title="Unregister SDK message processing steps so that you are able to delete the solution from Dynamics 365"
        (click)="clearSdkMessageProcessingSteps()"
        [disabled]="isReadOnly || data.status !== ServiceStatus.Stopped || data.highAvailabilityMode === HighAvailabilityModes.FailoverBackup"
      >
        <span class="fa fa-fw fa-list-alt mr-1" aria-hidden="true"></span>Clear Sdk message processing steps
      </button>
      @if (data.hasIssues && !isSaaS) {
      <button ngbDropdownItem data-toggle="tooltip" title="Reset the warning in the configuration status" (click)="resetIssues()" [disabled]="isReadOnly">
        <span class="fa fa-exclamation-triangle" aria-hidden="true" title="Warning"></span> Reset warnings
      </button>
      }
    </div>
  </div>

  <div ngbDropdown container="body">
    <button
      class="btn btn-sm btn-secondary dropdown-toggle"
      [id]="'otherActionsMenuButton#' + data.id"
      ngbDropdownToggle
      data-toggle="tooltip"
      title="Other Actions"
      [attr.aria-label]="'Open other actions for configuration ' + data.name + '. Press ESC to close the dropdown.'"
    >
      <span class="fa fa-bars" aria-hidden="true"></span>
    </button>
    <div ngbDropdownMenu [attr.aria-labelledby]="'otherActionsMenuButton#' + data.id">
      @if (isSaaS) {
      <button
        ngbDropdownItem
        [disabled]="isReadOnly"
        data-toggle="tooltip"
        data-placement="top"
        data-original-title="Activate token"
        data-toggle="modal"
        data-target="#activateTokenModal"
        [attr.data-token]="token"
        [attr.data-id]="data.id"
        [attr.data-workertype]="3"
        data-controlleraction="/api/Token/Activate"
      >
        <span class="fa fa-credit-card-alt mr-1" aria-hidden="true"></span>Activate token
      </button>
      }
      <a
        ngbDropdownItem
        data-toggle="tooltip"
        title="Customize your configuration settings"
        [attr.aria-label]="'Settings for configuration ' + data.name"
        [routerLink]="[data.id, 'settings']"
        (click)="navigateTo($event, [data.id, 'settings'])"
      >
        <span class="fa fa-fw fa-cog mr-1" aria-hidden="true"></span>Settings
      </a>
      <div class="divider dropdown-divider"></div>
      <a
        ngbDropdownItem
        data-toggle="tooltip"
        [title]="isReadOnly || isCustomerAgent ? 'View configuration details' : 'Edit configuration'"
        [attr.aria-label]="(isReadOnly || isCustomerAgent ? 'View configuration details of ' : 'Edit configuration ') + data.name"
        [routerLink]="[data.id]"
        (click)="navigateTo($event, [data.id])"
      >
        <span class="fa fa-fw {{ isReadOnly || isCustomerAgent ? 'fa-eye' : 'fa-edit' }} mr-1" aria-hidden="true"></span>
        {{ isReadOnly || isCustomerAgent ? 'View' : 'Edit' }}
      </a>
      <button
        ngbDropdownItem
        data-toggle="tooltip"
        title="Delete configuration"
        [disabled]="isReadOnly || isRunning || !bStartStopEnabled || isCustomerAgent"
        [attr.aria-label]="'Delete configuration ' + data.name + '?'"
        (click)="confirmDeletion()"
      >
        <span class="fa fa-fw fa-trash mr-1" aria-hidden="true"></span>Delete
      </button>
    </div>
  </div>
</div>
